
import { computed, defineComponent, ref, watch } from 'vue';

import { inputCompleted } from '@/hooks/use_input_completed_state';
import { useInsertDataStore } from '@/hooks/use_insert_data_store';
import { Item } from '@/models/item';
import { PurchaseStore } from '@/models/purchase_store';
import { SelectItem } from '@/models/select_item';
import items from '@/utils/prepare_items';
import stores from '@/utils/prepare_purchase_stores';
import selectItems from '@/utils/prepare_select_items';

export default defineComponent({
  name: 'ContentCustomizingVoiceBackground',

  components: {

  },
  setup() {
    const { purchaseItem } = useInsertDataStore();
    const { purchaseStore } = useInsertDataStore();
    const { selectedItem } = useInsertDataStore();

    if (!selectedItem.value) {
      selectedItem.value = new SelectItem();
    }

    const displayItems = computed(
      () => {
        if (purchaseStore.value !== undefined && purchaseStore.value.isMCC // MCC店舗
          && purchaseItem.value !== undefined && purchaseItem.value.limitedMCC) { // MCC対象商品
          return selectItems;
        }
        return selectItems.filter((item) => !item.limitedMCC); // それ以外は対象商品をフィルタ
      });
    const selectedImage = ref<SelectItem|undefined>();

    watch(selectedImage, () => {
      if (selectedImage.value) {
        inputCompleted.value = true;
        selectedItem.value = selectedImage.value;
      }
    });

    return {
      purchaseStore,
      purchaseItem,
      items,
      stores,
      displayItems,
      selectedImage,
    };
  },

});
